import { ChevronRight } from "lucide-react"
import { useNavigate } from "react-router-dom"


export default function TurmaFicha({turma}){
    const navigate = useNavigate()
    return(
        <div className="card-aluno" onClick={() => {
            navigate(`/turmas/${turma.id}`)
        }}>
            <div className="card-avatar">{turma.nome[0]}</div>
            <div className="card-info">
                <span className="card-nome">{turma.nome}</span>
                <span className="card-turma">{turma.descricao}</span>
            </div>
            <ChevronRight className="card-arrow" size={20} />
        </div>
    )
}